/*!
 * Copyright © 2018. Verizon Connect Ireland Limited. All rights reserved.
 */

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tooltipMessageCleaner'
})
export class TooltipMessageCleanerPipe implements PipeTransform {
  transform(sensors: string[]): string {
    const tooltipMessage: string = sensors.filter(string => string.length > 0).toString();

    return tooltipMessage;
  }
}
